<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
              [
                {title: 'You are here : '},
                {
                  title: 'Dashboard',
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: 'Create Question Bank',
                  active: true
                }
              ]
                "
            ></vs-breadcrumb>
            
            <!-- <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Training Information</h6>
            </div>-->
          </div>
          <CreateQuestionBank />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateQuestionBank from "../../commonPages/CreateQuestionBank";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    CreateQuestionBank
  },
  data: () => ({
    isSidebar: false
  })
};
</script>

<style scoped>
</style>


